module.exports = __webpack_public_path__ + "static/media/Thumb_1920x384_JCK_SummitIntro.4b761f19.jpeg";